import adminStyles from "./AdminStyles";

export function StatusBadge({ status }) {
  const color =
    status === "CONFIRMED"
      ? "#16a34a"
      : status === "FORCE_CHANGE_PASSWORD"
        ? "#f59e0b"
        : "#6b7280";

  return (
    <span style={{ ...adminStyles.badge, background: color }}>
      {status}
    </span>
  );
}

export function renderCustomerRoles(roles = []) {
  if (!Array.isArray(roles) || roles.length === 0) {
    return <span style={{ color: "#9ca3af" }}>—</span>;
  }

  return (
    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
      {roles.map((role) => (
        <span
          key={role}
          style={{
            padding: "2px 8px",
            borderRadius: 999,
            fontSize: 12,
            fontWeight: 600,
            background: "#ecfeff",
            color: "#155e75",
            whiteSpace: "nowrap",
          }}
        >
          {role}
        </span>
      ))}
    </div>
  );
}
